import {Table, Tbody, Td, Th, Thead, Tr} from '@chakra-ui/react';

const List = ({dataset}) => {
  return (
    <Table size='sm' marginY={2}>
      <Thead>
        <Tr>
          <Th>Level 1</Th>
          <Th>Level 2</Th>
          <Th>Level 3</Th>
          <Th>Message</Th>
          <Th>Form</Th>
          <Th>Attachment</Th>
        </Tr>
      </Thead>
      <Tbody>
        {dataset?.map((row, index) => <Tr key={'row-enquiry-' + index}>
          <Td>{row.Level_1}</Td>
          <Td>{row.Level_2}</Td>
          <Td>{row.Level_3}</Td>
          <Td>{row.Message}</Td>
          <Td>{row.Form}</Td>
          <Td>{row.attachment}</Td>
        </Tr>)}
      </Tbody>
    </Table>);
}

export default List;